module.exports = __webpack_public_path__ + "media/images/components/landing_pages/reassurance_cards/flexible@3x-b662e814f5a85da9de8b1e16f514edb8.png";